import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@/store/account'

export const useCurrentUser = () => {
  const currentUser = useSelector(selectCurrentUser)
  return currentUser
}

export default useCurrentUser
